// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#inviteGmail{margin-top:10px}#inviteGmail .invite_subtext{vertical-align:middle;font-size:14px}#inviteGmail .invite_checkbox{padding-left:0}#inviteGmail #select_invitation{max-width:250px}@media only screen and (max-width: 460px){#inviteGmail{justify-content:center;text-align:center}#inviteGmail .MuiGrid-item{margin:0 auto}#inviteGmail #copyInvitation{margin-top:10px}.autocomplete_field{min-width:100% !important}}\n", ""]);
// Exports
module.exports = exports;
